import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { useAdminAuth } from "hooks/useAdminAuth";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "components/ui/card";
import { Input } from "components/ui/input";
import { Label } from "components/ui/label";
import { Button } from "components/ui/button";
import { adminPaths } from "app/paths";

const AdminLogin: React.FC = () => {
  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState<string | null>(null);

  const { login } = useAdminAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setErro(null);
    setLoading(true);
    try {
      await login(email, senha);
      navigate(adminPaths.dashboard, { replace: true });
    } catch (err: any) {
      const msg = err?.response?.data?.erro || err?.message || "Falha ao entrar.";
      setErro(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="intrex-admin-scope min-h-screen w-full flex items-center justify-center bg-brand-sidebar px-4">
      <Card className="w-full max-w-sm border-0 shadow-2xl">
        <CardHeader className="items-center text-center gap-2">
          <div className="w-12 h-12 rounded-full bg-brand-primary/10 flex items-center justify-center">
            <ShieldCheck className="w-6 h-6 text-brand-primary" />
          </div>
          <CardTitle className="text-shopify-h2">Intrex Admin</CardTitle>
          <CardDescription>Acesso restrito à equipe interna</CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="admin-email">E-mail</Label>
              <Input
                id="admin-email"
                type="email"
                placeholder="voce@intrex.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <Label htmlFor="admin-senha">Senha</Label>
              <Input
                id="admin-senha"
                type="password"
                placeholder="••••••••"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                required
              />
            </div>

            {erro && <p className="text-sm text-red-600">{erro}</p>}

            <Button type="submit" disabled={loading} className="mt-2 bg-brand-sidebar hover:bg-brand-sidebar/90">
              {loading ? "Entrando..." : "Entrar"}
            </Button>
          </form>
        </CardContent>
      </Card>
    </div>
  );
};

export default AdminLogin;
